import { render, staticRenderFns } from "./QuestionnaireForm.component.vue?vue&type=template&id=c32cadf6"
import script from "./QuestionnaireForm.component.vue?vue&type=script&lang=js"
export * from "./QuestionnaireForm.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports